import template from './dialOptions.html';

export default {
  name: 'dialOptions',
  template,
  bindings: {
    options: '<',
    equipmentId: '<',
    panelId: '<',
    performActionMethod: '&',
    state: '<'
  },
  controllerAs: 'DialOptCtrl',
  controller: DialOptionsController
};

function DialOptionsController() {
  const vm = this;
  const POINT_DOWN = 270;
  const MAX_ANGLE = 180;

  let dialElement = null;
  let lastKnownEquipmentId = null;
  let lastKnownCurrentOption = null;

  vm.isActive = isActive;
  vm.calculateAngle = calculateAngle;
  vm.$onChanges = onChanges;

  function isActive(option) {
    return vm.state.currentOption === option.value;
  }

  function calculateAngle(total, index) {
    return (MAX_ANGLE / (total - 1)) * index;
  }

  function rotateDial(newAngle) {
    if (!dialElement) {
      dialElement = angular.element(`#panel-${vm.panelId}-dial-${vm.equipmentId}`);
    }
    dialElement.css('transform', `rotate(${newAngle}deg)`);
  }

  function onChanges(changes) {
    const newEquipmentId = _.get(changes, 'equipmentId.currentValue');
    if (newEquipmentId && newEquipmentId !== lastKnownEquipmentId) {
      lastKnownEquipmentId = newEquipmentId;
      // reset stored element to have rotateDial func grab from DOM
      dialElement = null;
    }
    const newCurrentOption = _.get(changes, 'state.currentValue.currentOption');
    if (lastKnownEquipmentId && newCurrentOption && newCurrentOption !== lastKnownCurrentOption) {
      lastKnownCurrentOption = newCurrentOption;
      const index = _.findIndex(vm.options, { value: newCurrentOption });
      if (index >= 0) {
        rotateDial(calculateAngle(vm.options.length, index));
      } else {
        rotateDial(POINT_DOWN);
      }
    }
  }
}
